<template>
  <div v-if="data" v-cloak>
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4" v-if="!path" v-html="data.nextstep.noPathText"></div>
        <div class="col-md-5" v-if="path">
          <!-- Progress -->
          <div class="progress">
            <div class="progress-bar" role="progressbar" style="width: 100%"
              aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <div v-if="path === 'radio_1177'" v-html="data.nextstep.nextstepCareguideText"></div>
          <div v-if="path === 'radio_calls_sms'" v-html="data.nextstep.nextstepCallsSmsText"></div>
          <div class="clearfix"></div>
          <small class="text-muted text-center" v-html="data.nextstep.nextstepDisclaimer"></small>
          <div class="clearfix"></div>
          <button class="btn btn-consent btn-primary btn-lg btn-block" @click="logOut()">
            Logga ut / stäng
          </button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { showDelayText } from '../plugins/delayhandler'
import config from '../../config/index.js'

export default {
  name: 'nextstep',
  components: {},
  data () {
    return {
      data: null,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      path: sessionStorage.getItem('path')
    }
  },
  methods: {
    logOut () {
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      this.$store.commit('setLogin', false)
      this.$store.commit('setName', null)
      var cookies = localStorage.getItem('vue-cookie-accept-decline-cookies')
      var access = localStorage.getItem('access')
      localStorage.clear()
      sessionStorage.clear()
      if (cookies) localStorage.setItem('vue-cookie-accept-decline-cookies', cookies)
      if (access) localStorage.setItem('access', access)
      loader.hide()
      window.location.href = window.location.origin
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          nextstep(locale: ` + sessionStorage.getItem('language') + `) {
            nextstepCareguideText
            nextstepCallsSmsText
            nextstepDisclaimer
            noPathText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button:disabled {
  opacity: 0.3;
}
.container {
  padding-bottom: 3vh;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-bottom: -6.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NextStep.vue